module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/4a0fd04df7da70aa2860667a75d6ab96.png";